import * as DropdownMenuRadix from "@radix-ui/react-dropdown-menu";
import classNames from "classnames";

interface DropdownMenuProps {
  triggerAsChild?: boolean;
  triggerChild: JSX.Element;
  ariaLabel: string;
  groups: {
    key: string;
    actions: {
      key: string;
      label: string;
      onClick: () => void;
      disabled?: boolean;
    }[];
  }[];
}

export function DropdownMenu({
  triggerAsChild = true,
  triggerChild,
  groups,
}: DropdownMenuProps) {
  return (
    <DropdownMenuRadix.Root>
      <DropdownMenuRadix.Trigger asChild={triggerAsChild}>
        {triggerChild}
      </DropdownMenuRadix.Trigger>

      <DropdownMenuRadix.Portal>
        <DropdownMenuRadix.Content
          className="bg-white rounded px-2 py-3 shadow-2xl min-w-[250px] border"
          sideOffset={5}
        >
          {groups.map((group, index) => {
            const actions = group.actions;

            return (
              <div key={group.key}>
                <DropdownMenuRadix.Group>
                  {actions
                    .filter((action) => !action.disabled)
                    .map((action) => (
                      <DropdownMenuRadix.Item
                        key={`${group.key}-${action.key}`}
                        onSelect={action.onClick}
                        disabled={action.disabled}
                        className={classNames(
                          "text-sm leading-none rounded-[2px] flex items-center h-6 px-1 py-4 select-none",
                          "outline-none relative hover:cursor-pointer hover:bg-primary-100",
                          "focus:bg-primary-100 focus:outline-none",
                        )}
                      >
                        {action.label}
                      </DropdownMenuRadix.Item>
                    ))}
                </DropdownMenuRadix.Group>
                {index < groups.length - 1 && (
                  <DropdownMenuRadix.Separator className="h-[1px] m-1 bg-primary-200" />
                )}
              </div>
            );
          })}
        </DropdownMenuRadix.Content>
      </DropdownMenuRadix.Portal>
    </DropdownMenuRadix.Root>
  );
}
